/**
 * Returns the subdomain from a Url (excluding www)
 * @param urlString - a Url
 *
 * @example
 * extractSubdomain("https://benamir.tophouse.com")
 * // "benamir"
 */
export default function extractSubdomain(urlString: string): string {
  const url = new URL(urlString);
  const { host } = url; // host will look like: benamir.tophouse.com or tophouse.com or localhost:3001
  const subdomain = host.split('.').slice(0, -2).join('.');
  const subdomainStripLeadingWww = subdomain.replace(/^www(\.?)/, '');
  return subdomainStripLeadingWww;
}
